
import { HttpProvider } from "../http/http.provider";
import { IAppConfig } from "../http/types/IApplicationConfig";

import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import { IHttpRequestConfig } from "../http";
import { IDemandRole, IDemandRoleResponse } from "./demand-role.interface";

/**
 * 
 */

export class DemandRoleDelegate
{
    constructor(private SERVICE_CONFIG: IAppConfig, private http: HttpProvider)
    {
    }

    public getAllDemandRoles(): Observable<IDemandRoleResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.DEMANDROLE.GET, null, config).pipe(
            map((response: any) =>
            {
                return {
                    demandRoles: DemandRoleDelegate.normalizeDemandRoles(response.data.roles || []),
                    success: response.data.success
                };
            }),
            share());
    }

    public createNewDemandRole(newDemandRole: IDemandRole): Observable<IDemandRoleResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.DEMANDROLE.CREATE, newDemandRole).pipe(
            map((response: any) =>
            {
                return {
                    demandRoles: DemandRoleDelegate.normalizeDemandRoles(response.data.roles || []),
                    success: response.data.success
                };
            }),
            share());
    }

    public updateDemandRole(demandRole: IDemandRole): Observable<IDemandRoleResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.DEMANDROLE.UPDATE, demandRole).pipe(
            map((response: any) =>
            {
                return {
                    demandRoles: DemandRoleDelegate.normalizeDemandRoles(response.data.roles || []),
                    success: response.data.success
                };
            }),
            share());
    }

    public static normalizeDemandRoles(roles: any): IDemandRole[]
    {
        return roles.map(role =>
        {
            return role;
        });
    }
}